import { useEffect, useLayoutEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { langOfPath } from "@/lib/locale";

const useIsoLayoutEffect = typeof window !== "undefined" ? useLayoutEffect : useEffect;

// 주소의 언어(/en → 영문)에 화면 언어와 <html lang> 을 맞춥니다. (첫 화면은 main.tsx · entry-server 가 미리 맞춤)
export default function LangSync() {
  const { pathname } = useLocation();
  const { i18n } = useTranslation();

  useIsoLayoutEffect(() => {
    const want = langOfPath(pathname);
    if (!i18n.language?.startsWith(want)) i18n.changeLanguage(want);
    document.documentElement.lang = want;
  }, [pathname, i18n]);

  return null;
}
